import type { EventFilter, TelemetryEvent } from './types';

/** A pattern an error message is matched against: a string matches by substring, a RegExp by `.test()`. */
export type NoisePattern = string | RegExp;

/** True when `message` matches any of `patterns`. */
export function isNoiseError(message: string, patterns: readonly NoisePattern[]): boolean {
  return patterns.some(pattern => (typeof pattern === 'string' ? message.includes(pattern) : pattern.test(message)));
}

/** Drops `type === 'error'` events whose message matches a noise pattern; other events pass through. */
export function dropNoiseErrors<T extends TelemetryEvent>(patterns: readonly NoisePattern[]): EventFilter<T> {
  return (event) => {
    if (event.type !== 'error') return true;
    const message = event.error?.message;
    return !message || !isNoiseError(message, patterns);
  };
}
